import { Vector3, type Matrix } from "@babylonjs/core";

/** Camera-space x/y at a given signed z, for any nonsingular projective camera.
 * Solve the two screen-coordinate equations directly; the NDC-depth row is
 * irrelevant because the depth texture already stores camera-space z.
 */
export class ContactShadowReconstruction {
  readonly xDepth = new Vector3();
  readonly xOffset = new Vector3();
  readonly yDepth = new Vector3();
  readonly yOffset = new Vector3();
  readonly denominator = new Vector3();
  private projection: Matrix | null = null;
  private updateFlag = -1;

  update(projection: Matrix): void {
    if (this.projection === projection && this.updateFlag === projection.updateFlag) return;
    this.projection = projection;
    this.updateFlag = projection.updateFlag;
    const m = projection.m;
    const a = m[0]!, b = m[4]!, c = m[1]!, d = m[5]!;
    const wx = m[3]!, wy = m[7]!;
    // Each vec3 is ordered as the coefficients of (NDC x, NDC y, 1).
    this.denominator.set(wy * c - wx * d, b * wx - a * wy, a * d - b * c);
    this.xDepth.set(d * m[11]! - wy * m[9]!, wy * m[8]! - b * m[11]!, b * m[9]! - d * m[8]!);
    this.xOffset.set(d * m[15]! - wy * m[13]!, wy * m[12]! - b * m[15]!, b * m[13]! - d * m[12]!);
    this.yDepth.set(wx * m[9]! - c * m[11]!, a * m[11]! - wx * m[8]!, c * m[8]! - a * m[9]!);
    this.yOffset.set(wx * m[13]! - c * m[15]!, a * m[15]! - wx * m[12]!, c * m[12]! - a * m[13]!);
  }
}
